import { render, staticRenderFns } from "./MortgageAddHandler.vue?vue&type=template&id=60afec20&scoped=true&"
import script from "./MortgageAddHandler.vue?vue&type=script&lang=js&"
export * from "./MortgageAddHandler.vue?vue&type=script&lang=js&"
import style0 from "./MortgageAddHandler.vue?vue&type=style&index=0&id=60afec20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afec20",
  null
  
)

export default component.exports